// useSetUploadFreshness - operator marks a whole upload out of date, or clears it
// back to fresh, from the Files tab. The flag is file-level and the agents' document
// inventory carries it too.
import { useMutation, useQueryClient } from "react-query";

import { queryKeys } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";

export interface SetUploadFreshnessInput {
  upload_id: string;
  project_id: string;
  out_of_date: boolean;
  updated_by?: string;
}

interface SetUploadFreshnessResult {
  upload_id: string;
  out_of_date: boolean;
}

export const useSetUploadFreshness = (projectId: string) => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<SetUploadFreshnessResult, Error, SetUploadFreshnessInput>(
    async (payload) =>
      http<SetUploadFreshnessResult>("/uploads/set_freshness", payload),
    {
      onSuccess: () => {
        qc.invalidateQueries({
          queryKey: queryKeys.uploadsList(projectId),
        });
        // Drive-sync rows live in the /uploads/tree response.
        qc.invalidateQueries({
          queryKey: queryKeys.uploadsTree(projectId),
        });
      },
    },
  );
};
